import React from 'react';

type IconProps = {
  iconWidth?: number;
  iconHeight?: number;
};

/**
 * FlipIcon is a component that displays a flip icon.
 *
 * @param {IconProps} props
 * @return {React.FC}
 */
const FlipIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      width={props.iconWidth || '24'}
      height={props.iconHeight || '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.5 14.5L4.5 19.5L9.5 24.5"
        stroke={'white'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 19.5H4.5"
        stroke={'white'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 9.5L19.5 4.5L14.5 -0.5"
        stroke={'white'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 4.5H19.5"
        stroke={'white'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FlipIcon;
